import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-add-certif-fournisseur',
    templateUrl: './add-certif-fournisseur.component.html',
    styleUrls: ['./add-certif-fournisseur.component.css']
})
export class AddCertifFournisseurComponent implements OnInit {

    titre_ajout_cons = 'Demande d\'enregistrement d\'une consultation';
    @ViewChild(MatStepper) stepper: MatStepper;

    // @ViewChild(LotOfferTableComponent) LotOfferTableComponent: LotOfferTableComponent;
    constructor(
        private toast: ToastService,
        private router: Router,
        private cdref: ChangeDetectorRef,
    ) {
    }

    onAdd() {
        this.stepper.next();
    }

    ngOnInit(): void {
    }

    submit(
        value: any,
        value2: any,
        value3: any,
    ) {

        const bj = Object.assign(value, value2, value3);



    }


    ngAfterViewInit(): void {
    }

    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }
}
